<template>
  <v-layout>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title ss="headline grey lighten-2" primary-title
          >Compra de Oportunidade</v-card-title
        >
        <v-card-text>
          <v-autocomplete
            v-model="selects.motivos.values"
            :items="selects.motivos.items"
            item-value="id"
            item-text="descricao"
            label="Motivo (os) de Compra"
            placeholder="Selecione um ou mais motivos para esta compra"
            class="mt-2"
            outlined
            chips
            small-chips
            multiple
            :error-messages="motivosErrors"
            @input="$v.selects.motivos.values.$touch()"
            @blur="$v.selects.motivos.values.$touch()"
          ></v-autocomplete>
          <p style="text-align: justify">
            Quantidade divergente da Sugerida. Selecione motivos que justifique
            esta tomada de decisão.
          </p>
          <div
            v-if="produtoSelecionado.acaoCompraOportunidade == 'mult' || mult"
            style="text-align: justify"
          >
            <p style="margin-bottom: 0; font-weight: bold">
              <v-icon>mdi-alert</v-icon>
              <span> ATENÇÃO</span>
            </p>
            Esses Motivos justificam todos os Produtos selecionados com
            Quantidade divergente da Sugerida.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="cancelar()">Fechar</v-btn>
          <v-btn color="primary" text @click="salvar(produtoSelecionado)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import CompraAPI from "./../../api/compra";

export default {
  props: ["dialog", "produto", "mult"],

  data: () => ({
    produtoSelecionado: {},
    selects: {
      motivos: {
        items: [],
        values: [],
      },
    },
  }),

  validations: {
    selects: {
      motivos: {
        values: {
          required() {
            if (this.dialog) {
              if (this.selects.motivos.values.length > 0) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          },
        },
      },
    },
  },

  computed: {
    motivosErrors() {
      const errors = [];
      if (!this.$v.selects.motivos.values.$dirty) return errors;
      !this.$v.selects.motivos.values.required &&
        errors.push("Campo Obrigatório.");
      return errors;
    },
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.buscarMotivos(this.produto);
      }
    },
  },

  methods: {
    cancelar: function () {
      this.$v.$reset();
      this.selects.motivos.values = [];
      this.$emit("cancelar");
    },

    fecharDialog: function () {
      this.$v.$reset();
      this.selects.motivos.values = [];
      this.$emit("fechar");
    },

    salvar: function () {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit("salvar", this.selects.motivos.values);
        this.fecharDialog();
      }
    },

    buscarMotivos: function (produto = { idpedido: "", idproduto: "" }) {
      if (!this.selects.motivos.items.length > 0 || produto.idpedido > 0) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          idpedido: produto.idpedido,
          idproduto: produto.idproduto,
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          CompraAPI.getMotivosCompraOportunidade(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.selects.motivos.items = response.data.motivos;
              this.selects.motivos.values = [];

              response.data.motivos.forEach((item) => {
                if (item.cadastrado && item.cadastrado > 0) {
                  this.selects.motivos.values.push(item.id);
                }
              });
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      } else {
        this.selects.motivos.values = [];
      }
    },
  },
};
</script>
